import { Page, PageTitle } from "@/components/page"
import { Brain } from "lucide-react"
import { SmartCMSPage } from "./SmartCMSPage"

export const smartCMS = {
  title: "Smart CMS",
  description: "AI-assisted CMS for help-center articles, the service map, and site configuration",
  route: "/smart-cms",
  url: "/smart-cms",
  icon: Brain,
  component,
  group: "docs",
  resource: "cms",
  action: "read",
} satisfies PageConfig

function component() {
  return (
    <Page>
      <SmartCMSPage />
    </Page>
  )
}
